
/**
 * 강의 난이도
 */
export type EnrollmentResponseCourseLevel = typeof EnrollmentResponseCourseLevel[keyof typeof EnrollmentResponseCourseLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentResponseCourseLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
